import { styled } from '@mui/material';

import Icon from '../Icon/Icon';

export const Hero = styled('section')(() => ({
  position: 'relative',
  width: '100%',
}));

export const Bottom = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: '64px',

  [theme.breakpoints.down('lg')]: {
    gap: '48px',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '32px',
  },
}));

export const PhoneBlock = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  paddingBottom: '118px',

  [theme.breakpoints.down('2xl')]: {
    paddingBottom: '85px',
  },
  [theme.breakpoints.down('xl')]: {
    paddingBottom: '72px',
  },
  [theme.breakpoints.down('lg')]: {
    paddingBottom: '40px',
  },
  [theme.breakpoints.down('md')]: {
    paddingBottom: '20px',
  },
  [theme.breakpoints.down('sm')]: {
    paddingBottom: '8px',
  },
}));

export const Phone = styled('img')(({ theme }) => ({
  width: '28.87%',

  [theme.breakpoints.down('2xl')]: {
    width: '28.02%',
  },
  [theme.breakpoints.down('lg')]: {
    width: '32%',
  },
  [theme.breakpoints.down('md')]: {
    width: '36%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '270px',
  },
}));

export const Logo = styled(Icon)(({ theme }) => ({
  position: 'absolute',
  zIndex: -1,
  left: 0,
  bottom: 0,
  width: '100%',
  height: 'auto',
  aspectRatio: '110 / 32',
  color: theme.palette.color.fg.primary,
}));

export const Cards = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '12px',
  width: '100%',

  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(1, 1fr)',
  },
}));

export const Decors = styled('div')(({ theme }) => ({
  position: 'absolute',
  zIndex: -2,
  bottom: '-192px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  pointerEvents: 'none',
  aspectRatio: '1 / 1',

  [theme.breakpoints.down('2xl')]: {
    bottom: '-334px',
  },
  [theme.breakpoints.down('lg')]: {
    bottom: '-180px',
  },
  [theme.breakpoints.down('md')]: {
    top: '260px',
    left: '50%',
    bottom: 'auto',
    width: '930px',
    transform: 'translateX(-50%)',
  },
  [theme.breakpoints.down('sm')]: {
    top: '184px',
    bottom: 'auto',
  },
}));

export const Circle = styled('span')(({ theme }) => ({
  position: 'absolute',
  borderRadius: '100%',
  border: `1px solid ${theme.palette.color.grey.light8}`,

  '&:first-of-type': {
    width: '100%',
    height: '100%',
  },
  '&:last-of-type': {
    width: '59.82%',
    height: '59.82%',

    [theme.breakpoints.down('md')]: {
      width: '560px',
      height: '560px',
    },
  },
}));
